import script from "./SupportEmailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportEmailCard.vue?vue&type=script&setup=true&lang=js"

import "./SupportEmailCard.vue?vue&type=style&index=0&id=2928dd9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2928dd9f"]])

export default __exports__